<template>
  <div>
    <v-row class="pt-4 pb-3 pl-4 pr-4 b-b mb-0" dense>
      <v-col>
        <v-text-field label="Search" outlined dense hide-details v-model="filters.searchString"></v-text-field>
      </v-col>
      <v-col>
        <v-btn block color="primary" elevation="0" @click="createCategory()">
          <v-icon size="small">mdi-plus</v-icon>
          Add category
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense no-gutters>
      <v-col :cols="showEditor ? 9 : 12">
        <div v-if="error" class="pa-4">
          <v-alert type="error" dismissible @input="error = false">
            Failed to load categories. Please try again later.
          </v-alert>
        </div>
        <div v-else class="list-view">
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="items"
            :search="filters.searchString"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            class="elevation-1"
            hide-default-footer
            @click:row="selectRow">
            <template slot="item.keywords" slot-scope="{ item }">
              {{ item.keywords }}
            </template>
            <template slot="item.displayPriority" slot-scope="{ item }">
              {{ item.displayPriority != null && item.displayPriority !== '' ? item.displayPriority : '' }}
            </template>
            <template slot="item.public" slot-scope="{ item }">
              <v-chip
                  label
                  small
                  outlined
                  :color="item.public ? 'success' : 'grey'">
                {{ item.public ? 'Public' : 'Hidden' }}
              </v-chip>
            </template>
          </v-data-table>
          <v-row class="pagination align-center">
            <v-col class="ml-2">
              <strong>Page {{ page }}</strong> of {{ pageCount }}
            </v-col>
            <v-col>
              <v-pagination v-model="page" :length="pageCount" total-visible="8"></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col class="b-l" v-if="showEditor">
        <div class="editor">
          <CategoryEditor :item="selectedCategory" :action="editorAction" @saved="getCategories()" @close="showEditor = false" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CategoryEditor from '@/components/CategoryEditor.vue';

export default {
  name: 'CategoryList',
  components: {
    CategoryEditor,
  },
  data() {
    return {
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Keywords', value: 'keywords' },
        { text: 'Display priority', value: 'displayPriority' },
        { text: 'Public', value: 'public' },
      ],
      filters: {
        searchString: '',
      },
      itemsPerPage: 10,
      page: 1,
      pageCount: 0,
      loading: false,
      error: false,
      showEditor: false,
      selectedCategory: {},
      editorAction: 'update',
    };
  },
  async mounted() {
    await this.getCategories();
  },
  methods: {
    async getCategories() {
      this.loading = true;
      this.error = false;
      try {
        await this.$store.dispatch('dispatchGetAdminCategories');
      } catch (error) {
        console.error('Failed to load categories:', error);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    selectRow(row) {
      this.selectedCategory = row;
      this.editorAction = 'update';
      this.showEditor = true;
    },
    createCategory() {
      this.selectedCategory = {
        id: '',
        name: '',
        keywords: '',
        public: true,
      };
      this.editorAction = 'create';
      this.showEditor = true;
    },
  },
  computed: {
    items() {
      return this.$store.state.adminCategories || [];
    },
  },
};
</script>

<style scoped>
.list-view {
  height: 70vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.editor {
  height: 70vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>

<style>
.pagination .v-pagination {
  justify-content: end;
}
</style>
